<template>
    <tr>
        <td class="editor-content editor-label">Border Radius</td>
        <td class="editor-content">
            <input class="form-control editor-form" type="number" v-model="selectedComponent.style.borderRadius"/>
        </td>
    </tr>
</template>

<script>
    export default {
        name: 'BorderRadiusEditor',
        props: ['selectedComponent'],
        data () {
            return {
                model: webase.model
            }
        }
    }
</script>

<style>

</style>
